import React, { ReactNode, createContext, useContext, useState } from 'react';

type InteracEmbedUrlFields = {
  interacEmbedUrl: string;
  transactionId: string;
  setTransactionId: (transactionId: string) => void;
  setInteracEmbedUrl: (interacEmbedUrl: string) => void;
};

export const InteracEmbedUrlFieldsContext = createContext<InteracEmbedUrlFields>({
  interacEmbedUrl: '',
  transactionId: '',
  setTransactionId: () => {},
  setInteracEmbedUrl: () => {},
});

export const InteracEmbedUrlProvider = ({ children }: { children: ReactNode }): React.JSX.Element => {
  const [interacEmbedUrl, setInteracEmbedUrl] = useState<string>('');
  const [transactionId, setTransactionId] = useState<string>('');

  return (
    <InteracEmbedUrlFieldsContext.Provider
      value={{
        interacEmbedUrl,
        transactionId,
        setTransactionId,
        setInteracEmbedUrl,
      }}
    >
      {children}
    </InteracEmbedUrlFieldsContext.Provider>
  );
};

export const useInteracEmbedUrlFields = (): InteracEmbedUrlFields => useContext(InteracEmbedUrlFieldsContext);
